(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssg-brands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ssg-brands]');
    if (!root) return;
    const d = root.dataset;
    const status = root.querySelector('[data-ssg-brands-status]');
    const form = root.querySelector('[data-ssg-brands-form]');
    const q = root.querySelector('[data-ssg-brands-q]');
    const none = root.querySelector('[data-ssg-brands-none]');
    const groups = [...root.querySelectorAll('[data-ssg-brands-group]')];
    const items = [...root.querySelectorAll('.ssg-brands__group li[data-vendor]')];
    const fold = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    const shown = () => items.filter((li) => !li.hidden && !li.classList.contains('is-miss'));
    let base = status.textContent; // the counting / done / failed line, restored when the box is emptied

    // A group shows while any of its brands is neither empty (hidden) nor a search miss.
    const showGroups = () => {
      let any = false;
      for (const g of groups) {
        const on = [...g.querySelectorAll('li')].some((li) => !li.hidden && !li.classList.contains('is-miss'));
        g.classList.toggle('is-miss', !on);
        any ||= on;
      }
      none.hidden = any;
    };

    let say;
    const filter = () => {
      const t = fold(q.value);
      for (const li of items) li.classList.toggle('is-miss', !!t && !fold(li.dataset.name || li.dataset.vendor).includes(t));
      root.toggleAttribute('data-searching', !!t);
      root.querySelector('[data-ssg-brands-search]').href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(q.value)}`;
      showGroups();
      // Tell screen readers once typing pauses, not on every key.
      clearTimeout(say);
      say = setTimeout(() => {
        const n = shown().length;
        status.textContent = t ? (n === 1 ? d.matchOne : d.match).replace('[count]', n).replace('[q]', q.value.trim()) : base;
      }, 400);
    };
    q.addEventListener('input', filter);
    // Enter / Go: put the keyboard away and go to the match (straight to the brand when there is only one).
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const hits = shown();
      q.blur();
      if (hits.length === 1) location.href = hits[0].querySelector('a').href;
      else hits[0]?.querySelector('a').focus();
    });

    const setBase = (text) => {
      base = text;
      if (!q.value.trim()) status.textContent = text;
    };
    const apply = ({ vc, cc }) => {
      for (const li of items) {
        const h = li.dataset.collection;
        let n = h ? cc[h] || 0 : 0;
        // Brand collection with nothing in stock: open the vendor page instead, and count that.
        if (!n) {
          n = vc[li.dataset.vendor] || 0;
          li.querySelector('a').href = li.dataset.vendorHref;
        }
        li.hidden = !n;
        li.querySelector('[data-count]').textContent = (n === 1 ? d.item : d.items).replace('[count]', n);
      }
      for (const li of root.querySelectorAll('[data-ssg-brands-featured] li[data-vendor]')) {
        const h = li.dataset.collection;
        const n = (h && cc[h]) || 0;
        if (!n) li.querySelector('a').href = li.dataset.vendorHref;
        li.hidden = !(n || vc[li.dataset.vendor]);
      }
      const featured = root.querySelector('[data-ssg-brands-featured]');
      if (featured) featured.hidden = !featured.querySelector('li:not([hidden])');
      // Letters whose brands all have no stock grey out, like letters with no brands at all.
      for (const g of groups) {
        const empty = ![...g.querySelectorAll('li')].some((li) => !li.hidden);
        g.hidden = empty;
        const a = root.querySelector(`a[data-ssg-brands-letter="${g.dataset.ssgBrandsGroup}"]`);
        if (empty && a) {
          const off = document.createElement('span');
          off.className = 'is-off';
          off.innerHTML = a.innerHTML;
          off.insertAdjacentHTML('beforeend', '<span class="visually-hidden"></span>');
          off.lastChild.textContent = ` ${d.off}`;
          a.replaceWith(off);
        }
      }
      showGroups();
      setBase(d.done.replace('[count]', items.filter((li) => !li.hidden).length));
      d.counted = 'true';
    };

    const wait = (ms) => new Promise((f) => setTimeout(f, ms));
    // One retry per page: a single 429 shouldn't leave brands with no stock listed.
    const page = async (n, tries = 2, src = d.source) => {
      try {
        const r = await fetch(`${src}&page=${n}`);
        if (!r.ok) throw new Error(r.status);
        const el = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-ssg-brands-data]');
        return JSON.parse(el.textContent);
      } catch (err) {
        if (tries < 2) throw err;
        await wait(1000);
        return page(n, tries - 1, src);
      }
    };
    const KEY = 'ssg-brands-counts-v3';
    const TTL = 10 * 60 * 1000;
    (async () => {
      let data;
      try {
        const c = JSON.parse(sessionStorage.getItem(KEY));
        if (c && Date.now() - c.t < TTL) data = c;
      } catch {}
      if (!data) {
        const first = await page(1);
        const rest = await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => page(i + 2)));
        const vc = {};
        const cc = {};
        for (const [v, hs] of [first, ...rest].flatMap((x) => x.p)) {
          vc[v] = (vc[v] || 0) + 1;
          for (const h of hs ? hs.split(' ') : []) cc[h] = (cc[h] || 0) + 1;
        }
        // Merged entries ("Shown as" with a collection) count that collection itself, so the number is what it shows.
        for (const h of new Set(items.map((li) => li.dataset.countCollection).filter(Boolean))) {
          const src = `${location.origin}/collections/${encodeURIComponent(h)}?filter.v.availability=1&section_id=ssg-brands-data`;
          const f = await page(1, 2, src);
          const more = await Promise.all(Array.from({ length: f.pages - 1 }, (_, i) => page(i + 2, 2, src)));
          cc[h] = [f, ...more].reduce((a, x) => a + x.p.length, 0);
        }
        data = { t: Date.now(), vc, cc };
        try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch {}
      }
      apply(data);
    })().catch(() => {
      setBase(d.failed);
      d.counted = 'failed';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
